import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export function convertDateTime(date: string) {
  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  });
}

export function convertDate(date: string) {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function getRandomColorTag() {
  return "geekblue";
}

export function formatDateTime(isoString: any) {
  return dayjs(isoString).format("h:mm A");
}

export function getRandomColor() {
  return [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ][Math.floor(Math.random() * 10)];
}

export function convertTime(date: string) {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  });
}

export const handleFileUpload = async (
  file: File,
  setFile: Function,
  setError: Function
) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const res = await fetch("/upload", {
      method: "POST",
      body: formData,
    });

    if (res.status === 200) {
      const data = await res.json();
      setFile(data.file);
    } else {
      setError(await res.text());
    }
  } catch (err: any) {
    setError(err.message);
  }
};

export function formatDate(dateStr: string) {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const date = new Date(dateStr);
  const day = date.getDate().toString().padStart(2, "0");
  const monthIndex = date.getMonth();
  const monthName = months[monthIndex];
  const year = date.getFullYear();

  return `${day}-${monthName}-${year}`;
}

export function formatTime(timeStr: any) {
  const date = new Date(timeStr);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  const formattedTime = `${hours}:${minutes
    .toString()
    .padStart(2, "0")} ${period}`;
  return formattedTime;
}

export function convertToIST(dateString: string): string {
  const date = new Date(dateString);

  const weekday = date.toLocaleString("en-US", {
    weekday: "short",
    timeZone: "Asia/Kolkata",
  });
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "Asia/Kolkata",
  });
  const day = date.toLocaleString("en-US", {
    day: "2-digit",
    timeZone: "Asia/Kolkata",
  });
  const year = date.toLocaleString("en-US", {
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
  const time = date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  });

  const istOffset = "+0530";
  const istString = `GMT${istOffset} (India Standard Time)`;

  const formattedDate = `${weekday} ${month} ${day} ${year} ${time} ${istString}`;

  return formattedDate;
}

export const getFileMimeTypeImage = (fileName: string): string => {
  if (fileName.includes("pdf")) {
    return "/icons/pdf_logo.svg";
  } else if (fileName.includes("doc") && !fileName.includes("docx")) {
    return "/icons/doc_logo.svg";
  } else if (fileName.includes("docx")) {
    return "/icons/docx_logo.svg";
  } else {
    return "/icons/pdf_logo.svg";
  }
};

export function updateMetaData(
  description: string | null,
  title: string | null
) {
  const metaDescription = document.querySelector('meta[name="description"]');
  const metaTitle = document.querySelector('meta[name="title"]');

  if (metaDescription && description) {
    metaDescription.setAttribute("content", description);
  }
  if (metaTitle && title) {
    metaTitle.setAttribute("content", title);
  }
}

export function validateEmailWithMessage(email: string): { 
  isValid: boolean; 
  message: string; 
} {
  if (!email) {
    return { isValid: false, message: "Email is required" };
  }

  if (!email.includes('@')) {
    return { isValid: false, message: "Email must contain @ symbol" };
  }

  if (email.length < 5) {
    return { isValid: false, message: "Email is too short" };
  }

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, message: "Please enter a valid email address" };
  }

  return { isValid: true, message: "Valid email address" };
}

export function getGradientStyle(primaryColor: string) {
  return {
  background: `linear-gradient(135deg, ${primaryColor}20, ${primaryColor})`, 
  };
}

export function getDeviceType(): "mobile" | "tablet" | "desktop" {
  const ua = navigator.userAgent;
  const width = window.innerWidth;
  const hasTouch = "ontouchstart" in window;

  if (/Mobi|Android/i.test(ua) || (hasTouch && width <= 767)) {
    return "mobile";
  }

  if (/Tablet|iPad/i.test(ua) || (hasTouch && width > 767 && width <= 1024)) {
    return "tablet";
  }

  return "desktop";
};